import BaseDialog from "../../modelDialogs/BaseDialog";

export default function CheckIfGoingBackDialog(props: { onOk: () => boolean }) {
  const { onOk } = props;
  return (
    <BaseDialog
      title={state.translate("checkIfGoingBackDialog.backToStart", "Zurück zum Start?")}
      okCaption={state.translate("back", "Zurück")}
      onOk={onOk}
    >
      <div>
        {state.translate(
          "checkIfGoingBackDialog.backSoStartWithoutCreating",
          "Wirklich zurück zum Start ohne dieses Projekt zu erstellen?",
        )}
      </div>
    </BaseDialog>
  );
}

